// eslint-disable-next-line import/prefer-default-export
export const country = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cote D"Ivoire', code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, Democratic People"S Republic of', code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Lao People"S Democratic Republic', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];

export const products = [
  {
    id: '1000',
    code: 'f230fh0g3',
    name: 'Bamboo Watch',
    description: 'Product Description',
    image: 'bamboo-watch.jpg',
    price: 65,
    category: 'Accessories',
    quantity: 24,
    inventoryStatus: 'INSTOCK',
    rating: 5,
    orders: [
      {
        id: '1000',
        productCode: 'f230fh0g3',
        date: '2020-09-13',
        amount: 65,
        quantity: 1,
        customer: 'David James',
        status: 'PENDING',
      },
      {
        id: '1001',
        productCode: 'f230fh0g3',
        date: '2020-05-14',
        amount: 130,
        quantity: 2,
        customer: 'Leon Rodrigues',
        status: 'DELIVERED',
      },
      {
        id: '1002',
        productCode: 'f230fh0g3',
        date: '2019-01-04',
        amount: 65,
        quantity: 1,
        customer: 'Juan Alejandro',
        status: 'RETURNED',
      },
      {
        id: '1003',
        productCode: 'f230fh0g3',
        date: '2020-09-13',
        amount: 195,
        quantity: 3,
        customer: 'Claire Morrow',
        status: 'CANCELLED',
      },
    ],
  },
  {
    id: '1001',
    code: 'nvklal433',
    name: 'Black Watch',
    description: 'Product Description',
    image: 'black-watch.jpg',
    price: 72,
    category: 'Accessories',
    quantity: 61,
    inventoryStatus: 'INSTOCK',
    rating: 4,
    orders: [
      {
        id: '2000',
        productCode: 'nvklal433',
        date: '2020-05-14',
        amount: 72,
        quantity: 1,
        customer: 'Maisha Jefferson',
        status: 'DELIVERED',
      },
      {
        id: '2001',
        productCode: 'nvklal433',
        date: '2020-02-28',
        amount: 144,
        quantity: 2,
        customer: 'Octavia Murillo',
        status: 'PENDING',
      },
    ],
  },
  {
    id: '1002',
    code: 'zz21cz3c1',
    name: 'Blue Band',
    description: 'Product Description',
    image: 'blue-band.jpg',
    price: 79,
    category: 'Fitness',
    quantity: 2,
    inventoryStatus: 'LOWSTOCK',
    rating: 3,
    orders: [
      {
        id: '3000',
        productCode: 'zz21cz3c1',
        date: '2020-07-05',
        amount: 79,
        quantity: 1,
        customer: 'Stacey Leja',
        status: 'DELIVERED',
      },
      {
        id: '3001',
        productCode: 'zz21cz3c1',
        date: '2020-02-06',
        amount: 79,
        quantity: 1,
        customer: 'Ashley Wickens',
        status: 'DELIVERED',
      },
    ],
  },
  {
    id: '1003',
    code: '244wgerg2',
    name: 'Blue T-Shirt',
    description: 'Product Description',
    image: 'blue-t-shirt.jpg',
    price: 29,
    category: 'Clothing',
    quantity: 25,
    inventoryStatus: 'INSTOCK',
    rating: 5,
    orders: [],
  },
  {
    id: '1004',
    code: 'h456wer53',
    name: 'Bracelet',
    description: 'Product Description',
    image: 'bracelet.jpg',
    price: 15,
    category: 'Accessories',
    quantity: 73,
    inventoryStatus: 'INSTOCK',
    rating: 4,
    orders: [
      {
        id: '5000',
        productCode: 'h456wer53',
        date: '2020-09-05',
        amount: 60,
        quantity: 4,
        customer: 'Mayumi Misaki',
        status: 'PENDING',
      },
      {
        id: '5001',
        productCode: 'h456wer53',
        date: '2019-04-16',
        amount: 2,
        quantity: 30,
        customer: 'Francesco Salvatore',
        status: 'DELIVERED',
      },
    ],
  },
  {
    id: '1005',
    code: 'av2231fwg',
    name: 'Brown Purse',
    description: 'Product Description',
    image: 'brown-purse.jpg',
    price: 120,
    category: 'Accessories',
    quantity: 0,
    inventoryStatus: 'OUTOFSTOCK',
    rating: 4,
    orders: [
      {
        id: '6000',
        productCode: 'av2231fwg',
        date: '2020-01-25',
        amount: 120,
        quantity: 1,
        customer: 'Isabel Sinclair',
        status: 'RETURNED',
      },
      {
        id: '6001',
        productCode: 'av2231fwg',
        date: '2019-03-12',
        amount: 240,
        quantity: 2,
        customer: 'Lionel Clifford',
        status: 'DELIVERED',
      },
      {
        id: '6002',
        productCode: 'av2231fwg',
        date: '2019-05-05',
        amount: 120,
        quantity: 1,
        customer: 'Cody Chavez',
        status: 'DELIVERED',
      },
    ],
  },
  {
    id: '1006',
    code: 'bib36pfvm',
    name: 'Chakra Bracelet',
    description: 'Product Description',
    image: 'chakra-bracelet.jpg',
    price: 32,
    category: 'Accessories',
    quantity: 5,
    inventoryStatus: 'LOWSTOCK',
    rating: 3,
    orders: [
      {
        id: '7000',
        productCode: 'bib36pfvm',
        date: '2020-02-24',
        amount: 32,
        quantity: 1,
        customer: 'Arvin Darci',
        status: 'DELIVERED',
      },
      {
        id: '7001',
        productCode: 'bib36pfvm',
        date: '2020-01-14',
        amount: 64,
        quantity: 2,
        customer: 'Izzy Jones',
        status: 'PENDING',
      },
    ],
  },
  {
    id: '1007',
    code: 'mbvjkgip5',
    name: 'Galaxy Earrings',
    description: 'Product Description',
    image: 'galaxy-earrings.jpg',
    price: 34,
    category: 'Accessories',
    quantity: 23,
    inventoryStatus: 'INSTOCK',
    rating: 5,
    orders: [
      {
        id: '8000',
        productCode: 'mbvjkgip5',
        date: '2020-06-19',
        amount: 34,
        quantity: 1,
        customer: 'Jennifer Smith',
        status: 'DELIVERED',
      },
    ],
  },
  {
    id: '1008',
    code: 'vbb124btr',
    name: 'Game Controller',
    description: 'Product Description',
    image: 'game-controller.jpg',
    price: 99,
    category: 'Electronics',
    quantity: 2,
    inventoryStatus: 'LOWSTOCK',
    rating: 4,
    orders: [
      {
        id: '9000',
        productCode: 'vbb124btr',
        date: '2020-01-05',
        amount: 99,
        quantity: 1,
        customer: 'Jeanfrancois David',
        status: 'DELIVERED',
      },
      {
        id: '9001',
        productCode: 'vbb124btr',
        date: '2020-01-19',
        amount: 198,
        quantity: 2,
        customer: 'Ivar Greenwood',
        status: 'RETURNED',
      },
    ],
  },
  {
    id: '1009',
    code: 'cm230f032',
    name: 'Gaming Set',
    description: 'Product Description',
    image: 'gaming-set.jpg',
    price: 299,
    category: 'Electronics',
    quantity: 63,
    inventoryStatus: 'INSTOCK',
    rating: 3,
    orders: [
      {
        id: '10000',
        productCode: 'cm230f032',
        date: '2020-06-24',
        amount: 299,
        quantity: 1,
        customer: 'Kadeem Mujtaba',
        status: 'PENDING',
      },
      {
        id: '10001',
        productCode: 'cm230f032',
        date: '2020-05-11',
        amount: 299,
        quantity: 1,
        customer: 'Ashley Wickens',
        status: 'DELIVERED',
      },
      {
        id: '10002',
        productCode: 'cm230f032',
        date: '2019-02-07',
        amount: 299,
        quantity: 1,
        customer: 'Julie Johnson',
        status: 'DELIVERED',
      },
      {
        id: '10003',
        productCode: 'cm230f032',
        date: '2020-04-26',
        amount: 299,
        quantity: 1,
        customer: 'Tony Costa',
        status: 'CANCELLED',
      },
    ],
  },
];

export const customer = [
  {
    id: 1000,
    name: 'James Butt',
    country: { name: 'Algeria', code: 'dz' },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    activity: 17,
    representative: { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
  },
  {
    id: 1001,
    name: 'Josephine Darakjy',
    country: { name: 'Egypt', code: 'eg' },
    company: 'Chanay, Jeffrey A Esq',
    date: '2019-02-09',
    status: 'proposal',
    activity: 0,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1002,
    name: 'Art Venere',
    country: { name: 'Panama', code: 'pa' },
    company: 'Chemel, James L Cpa',
    date: '2017-05-13',
    status: 'qualified',
    activity: 63,
    representative: { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
  },
  {
    id: 1003,
    name: 'Lenna Paprocki',
    country: { name: 'Slovenia', code: 'si' },
    company: 'Feltz Printing Service',
    date: '2020-09-15',
    status: 'new',
    activity: 37,
    representative: { name: 'Xuxue Feng', image: 'xuxuefeng.png' },
  },
  {
    id: 1004,
    name: 'Donette Foller',
    country: { name: 'South Africa', code: 'za' },
    company: 'Printing Dimensions',
    date: '2016-05-20',
    status: 'proposal',
    activity: 33,
    representative: { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
  },
  {
    id: 1005,
    name: 'Simona Morasca',
    country: { name: 'Egypt', code: 'eg' },
    company: 'Chapman, Ross E Esq',
    date: '2018-02-16',
    status: 'qualified',
    activity: 68,
    representative: { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
  },
  {
    id: 1006,
    name: 'Mitsue Tollner',
    country: { name: 'Paraguay', code: 'py' },
    company: 'Morlong Associates',
    date: '2018-02-19',
    status: 'renewal',
    activity: 54,
    representative: { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
  },
  {
    id: 1007,
    name: 'Leota Dilliard',
    country: { name: 'Serbia', code: 'rs' },
    company: 'Commercial Press',
    date: '2019-08-13',
    status: 'renewal',
    activity: 69,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1008,
    name: 'Sage Wieser',
    country: { name: 'Egypt', code: 'eg' },
    company: 'Truhlar And Truhlar Attys',
    date: '2018-11-21',
    status: 'unqualified',
    activity: 76,
    representative: { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
  },
  {
    id: 1009,
    name: 'Kris Marrier',
    country: { name: 'Mexico', code: 'mx' },
    company: 'King, Christopher A Esq',
    date: '2015-07-07',
    status: 'proposal',
    activity: 3,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1010,
    name: 'Minna Amigon',
    country: { name: 'Romania', code: 'ro' },
    company: 'Dorl, James J Esq',
    date: '2018-11-07',
    status: 'qualified',
    activity: 38,
    representative: { name: 'Anna Fali', image: 'annafali.png' },
  },
  {
    id: 1011,
    name: 'Abel Maclead',
    country: { name: 'Singapore', code: 'sg' },
    company: 'Rangoni Of Florence',
    date: '2017-03-11',
    status: 'qualified',
    activity: 87,
    representative: { name: 'Bernardo Dominic', image: 'bernardodominic.png' },
  },
  {
    id: 1012,
    name: 'Kiley Caldarera',
    country: { name: 'Serbia', code: 'rs' },
    company: 'Feiner Bros',
    date: '2015-10-20',
    status: 'unqualified',
    activity: 80,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1013,
    name: 'Graciela Ruta',
    country: { name: 'Chile', code: 'cl' },
    company: 'Buckley Miller & Wright',
    date: '2016-07-25',
    status: 'negotiation',
    activity: 59,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1014,
    name: 'Cammy Albares',
    country: { name: 'Philippines', code: 'ph' },
    company: 'Rousseaux, Michael Esq',
    date: '2019-06-25',
    status: 'new',
    activity: 90,
    representative: { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
  },
  {
    id: 1015,
    name: 'Mattie Poquette',
    country: { name: 'Venezuela', code: 've' },
    company: 'Century Communications',
    date: '2017-12-12',
    status: 'negotiation',
    activity: 52,
    representative: { name: 'Anna Fali', image: 'annafali.png' },
  },
  {
    id: 1016,
    name: 'Meaghan Garufi',
    country: { name: 'Malaysia', code: 'my' },
    company: 'Bolton, Wilbur Esq',
    date: '2018-07-04',
    status: 'unqualified',
    activity: 31,
    representative: { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
  },
  {
    id: 1017,
    name: 'Gladys Rim',
    country: { name: 'Netherlands', code: 'nl' },
    company: 'T M Byxbee Company Pc',
    date: '2020-02-27',
    status: 'renewal',
    activity: 48,
    representative: { name: 'Stephen Shaw', image: 'stephenshaw.png' },
  },
  {
    id: 1018,
    name: 'Yuki Whobrey',
    country: { name: 'Israel', code: 'il' },
    company: 'Farmers Insurance Group',
    date: '2017-12-21',
    status: 'negotiation',
    activity: 16,
    representative: { name: 'Bernardo Dominic', image: 'bernardodominic.png' },
  },
  {
    id: 1019,
    name: 'Fletcher Flosi',
    country: { name: 'Argentina', code: 'ar' },
    company: 'Post Box Services Plus',
    date: '2016-01-04',
    status: 'renewal',
    activity: 19,
    representative: { name: 'Xuxue Feng', image: 'xuxuefeng.png' },
  },
  {
    id: 1020,
    name: 'Bette Nicka',
    country: { name: 'Paraguay', code: 'py' },
    company: 'Sport En Art',
    date: '2016-10-21',
    status: 'renewal',
    activity: 100,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1021,
    name: 'Veronika Inouye',
    country: { name: 'Ecuador', code: 'ec' },
    company: 'C 4 Network Inc',
    date: '2017-03-24',
    status: 'renewal',
    activity: 72,
    representative: { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
  },
  {
    id: 1022,
    name: 'Willard Kolmetz',
    country: { name: 'Tunisia', code: 'tn' },
    company: 'Ingalls, Donald R Esq',
    date: '2017-04-15',
    status: 'renewal',
    activity: 94,
    representative: { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
  },
  {
    id: 1023,
    name: 'Maryann Royster',
    country: { name: 'Belarus', code: 'by' },
    company: 'Franklin, Peter L Esq',
    date: '2017-03-11',
    status: 'qualified',
    activity: 56,
    representative: { name: 'Elwin Sharvill', image: 'elwinsharvill.png' },
  },
  {
    id: 1024,
    name: 'Alisha Slusarski',
    country: { name: 'Iceland', code: 'is' },
    company: 'Wtlz Power 107 Fm',
    date: '2018-03-27',
    status: 'qualified',
    activity: 7,
    representative: { name: 'Stephen Shaw', image: 'stephenshaw.png' },
  },
  {
    id: 1025,
    name: 'Allene Iturbide',
    country: { name: 'Italy', code: 'it' },
    company: 'Ledecky, David Esq',
    date: '2016-02-20',
    status: 'qualified',
    activity: 1,
    representative: { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
  },
  {
    id: 1026,
    name: 'Chanel Caudy',
    country: { name: 'Argentina', code: 'ar' },
    company: 'Professional Image Inc',
    date: '2018-06-24',
    status: 'new',
    activity: 26,
    representative: { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
  },
  {
    id: 1027,
    name: 'Ezekiel Chui',
    country: { name: 'Ireland', code: 'ie' },
    company: 'Sider, Donald C Esq',
    date: '2016-09-24',
    status: 'new',
    activity: 76,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1028,
    name: 'Willow Kusko',
    country: { name: 'Romania', code: 'ro' },
    company: 'U Pull It',
    date: '2020-04-11',
    status: 'qualified',
    activity: 7,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1029,
    name: 'Bernardo Figeroa',
    country: { name: 'Israel', code: 'il' },
    company: 'Clark, Richard Cpa',
    date: '2018-04-11',
    status: 'renewal',
    activity: 81,
    representative: { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
  },
  {
    id: 1030,
    name: 'Ammie Corrio',
    country: { name: 'Hungary', code: 'hu' },
    company: 'Moskowitz, Barry S',
    date: '2016-06-11',
    status: 'negotiation',
    activity: 56,
    representative: { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
  },
  {
    id: 1031,
    name: 'Francine Vocelka',
    country: { name: 'Honduras', code: 'hn' },
    company: 'Cascade Realty Advisors Inc',
    date: '2017-08-02',
    status: 'qualified',
    activity: 94,
    representative: { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
  },
  {
    id: 1032,
    name: 'Ernie Stenseth',
    country: { name: 'Australia', code: 'au' },
    company: 'Knwz Newsradio',
    date: '2018-06-06',
    status: 'renewal',
    activity: 68,
    representative: { name: 'Xuxue Feng', image: 'xuxuefeng.png' },
  },
  {
    id: 1033,
    name: 'Albina Glick',
    country: { name: 'Ukraine', code: 'ua' },
    company: 'Giampetro, Anthony D',
    date: '2019-08-08',
    status: 'proposal',
    activity: 85,
    representative: { name: 'Bernardo Dominic', image: 'bernardodominic.png' },
  },
  {
    id: 1034,
    name: 'Alishia Sergi',
    country: { name: 'Qatar', code: 'qa' },
    company: 'Milford Enterprises Inc',
    date: '2018-05-19',
    status: 'negotiation',
    activity: 46,
    representative: { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
  },
  {
    id: 1035,
    name: 'Solange Shinko',
    country: { name: 'Cameroon', code: 'cm' },
    company: 'Mosocco, Ronald A',
    date: '2015-02-12',
    status: 'qualified',
    activity: 32,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1036,
    name: 'Jose Stockham',
    country: { name: 'Italy', code: 'it' },
    company: 'Tri State Refueler Co',
    date: '2018-04-25',
    status: 'qualified',
    activity: 77,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1037,
    name: 'Rozella Ostrosky',
    country: { name: 'Venezuela', code: 've' },
    company: 'Parkway Company',
    date: '2016-02-27',
    status: 'unqualified',
    activity: 66,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1038,
    name: 'Valentine Gillian',
    country: { name: 'Paraguay', code: 'py' },
    company: 'Fbs Business Finance',
    date: '2019-09-17',
    status: 'qualified',
    activity: 25,
    representative: { name: 'Bernardo Dominic', image: 'bernardodominic.png' },
  },
  {
    id: 1039,
    name: 'Kati Rulapaugh',
    country: { name: 'Puerto Rico', code: 'pr' },
    company: 'Eder Assocs Consltng Engrs Pc',
    date: '2016-12-03',
    status: 'renewal',
    activity: 51,
    representative: { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
  },
  {
    id: 1040,
    name: 'Youlanda Schemmer',
    country: { name: 'Bolivia', code: 'bo' },
    company: 'Tri M Tool Inc',
    date: '2017-12-15',
    status: 'negotiation',
    activity: 49,
    representative: { name: 'Xuxue Feng', image: 'xuxuefeng.png' },
  },
  {
    id: 1041,
    name: 'Dyan Oldroyd',
    country: { name: 'Argentina', code: 'ar' },
    company: 'International Eyelets Inc',
    date: '2017-02-02',
    status: 'qualified',
    activity: 5,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1042,
    name: 'Roxane Campain',
    country: { name: 'France', code: 'fr' },
    company: 'Rapid Trading Intl',
    date: '2018-12-25',
    status: 'unqualified',
    activity: 100,
    representative: { name: 'Anna Fali', image: 'annafali.png' },
  },
  {
    id: 1043,
    name: 'Lavera Perin',
    country: { name: 'Vietnam', code: 'vn' },
    company: 'Abc Enterprises Inc',
    date: '2018-04-10',
    status: 'qualified',
    activity: 71,
    representative: { name: 'Stephen Shaw', image: 'stephenshaw.png' },
  },
  {
    id: 1044,
    name: 'Erick Ferencz',
    country: { name: 'Belgium', code: 'be' },
    company: 'Cindy Turner Associates',
    date: '2018-05-06',
    status: 'unqualified',
    activity: 54,
    representative: { name: 'Amy Elsner', image: 'amyelsner.png' },
  },
  {
    id: 1045,
    name: 'Fatima Saylors',
    country: { name: 'Canada', code: 'ca' },
    company: 'Stanton, James D Esq',
    date: '2019-07-10',
    status: 'renewal',
    activity: 93,
    representative: { name: 'Onyama Limba', image: 'onyamalimba.png' },
  },
  {
    id: 1046,
    name: 'Jina Briddick',
    country: { name: 'Mexico', code: 'mx' },
    company: 'Grace Pastries Inc',
    date: '2018-02-19',
    status: 'unqualified',
    activity: 97,
    representative: { name: 'Xuxue Feng', image: 'xuxuefeng.png' },
  },
  {
    id: 1047,
    name: 'Kanisha Waycott',
    country: { name: 'Ecuador', code: 'ec' },
    company: 'Schroer, Gene E Esq',
    date: '2019-11-27',
    status: 'new',
    activity: 80,
    representative: { name: 'Xuxue Feng', image: 'xuxuefeng.png' },
  },
  {
    id: 1048,
    name: 'Emerson Bowley',
    country: { name: 'Finland', code: 'fi' },
    company: 'Knights Inn',
    date: '2018-11-24',
    status: 'new',
    activity: 63,
    representative: { name: 'Stephen Shaw', image: 'stephenshaw.png' },
  },
  {
    id: 1049,
    name: 'Blair Malet',
    country: { name: 'Finland', code: 'fi' },
    company: 'Bollinger Mach Shp & Shipyard',
    date: '2018-04-19',
    status: 'new',
    activity: 92,
    representative: { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
  },
];

export const treeNodes = [
  {
    key: '0',
    label: 'Documents',
    data: 'Documents Folder',
    icon: 'pi pi-fw pi-inbox',
    children: [
      {
        key: '0-0',
        label: 'Work',
        data: 'Work Folder',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-0-0',
            label: 'Expenses.doc',
            icon: 'pi pi-fw pi-file',
            data: 'Expenses Document',
          },
          {
            key: '0-0-1',
            label: 'Resume.doc',
            icon: 'pi pi-fw pi-file',
            data: 'Resume Document',
          },
        ],
      },
      {
        key: '0-1',
        label: 'Home',
        data: 'Home Folder',
        icon: 'pi pi-fw pi-home',
        children: [
          {
            key: '0-1-0',
            label: 'Invoices.txt',
            icon: 'pi pi-fw pi-file',
            data: 'Invoices for this month',
          },
        ],
      },
    ],
  },
  {
    key: '1',
    label: 'Events',
    data: 'Events Folder',
    icon: 'pi pi-fw pi-calendar',
    children: [
      {
        key: '1-0',
        label: 'Meeting',
        icon: 'pi pi-fw pi-calendar-plus',
        data: 'Meeting',
      },
      {
        key: '1-1',
        label: 'Product Launch',
        icon: 'pi pi-fw pi-calendar-plus',
        data: 'Product Launch',
      },
      {
        key: '1-2',
        label: 'Report Review',
        icon: 'pi pi-fw pi-calendar-plus',
        data: 'Report Review',
      },
    ],
  },
  {
    key: '2',
    label: 'Movies',
    data: 'Movies Folder',
    icon: 'pi pi-fw pi-star',
    children: [
      {
        key: '2-0',
        icon: 'pi pi-fw pi-star',
        label: 'Al Pacino',
        data: 'Pacino Movies',
        children: [
          {
            key: '2-0-0',
            label: 'Scarface',
            icon: 'pi pi-fw pi-video',
            data: 'Scarface Movie',
          },
          {
            key: '2-0-1',
            label: 'Serpico',
            icon: 'pi pi-fw pi-video',
            data: 'Serpico Movie',
          },
        ],
      },
      {
        key: '2-1',
        label: 'Robert De Niro',
        icon: 'pi pi-fw pi-star',
        data: 'De Niro Movies',
        children: [
          {
            key: '2-1-0',
            label: 'Goodfellas',
            icon: 'pi pi-fw pi-video',
            data: 'Goodfellas Movie',
          },
          {
            key: '2-1-1',
            label: 'Untouchables',
            icon: 'pi pi-fw pi-video',
            data: 'Untouchables Movie',
          },
        ],
      },
    ],
  },
];

export const treeTableNodes = [
  {
    key: '0',
    data: { name: 'Applications', size: '100kb', type: 'Folder' },
    children: [
      {
        key: '0-0',
        data: { name: 'React', size: '25kb', type: 'Folder' },
        children: [
          {
            key: '0-0-0',
            data: { name: 'react.app', size: '10kb', type: 'Application' },
          },
          {
            key: '0-0-1',
            data: { name: 'native.app', size: '10kb', type: 'Application' },
          },
          {
            key: '0-0-2',
            data: { name: 'mobile.app', size: '5kb', type: 'Application' },
          },
        ],
      },
      {
        key: '0-1',
        data: { name: 'editor.app', size: '25kb', type: 'Application' },
      },
      {
        key: '0-2',
        data: { name: 'settings.app', size: '50kb', type: 'Application' },
      },
    ],
  },
  {
    key: '1',
    data: { name: 'Cloud', size: '20kb', type: 'Folder' },
    children: [
      { key: '1-0', data: { name: 'backup-1.zip', size: '10kb', type: 'Zip' } },
      { key: '1-1', data: { name: 'backup-2.zip', size: '10kb', type: 'Zip' } },
    ],
  },
  {
    key: '2',
    data: { name: 'Desktop', size: '150kb', type: 'Folder' },
    children: [
      {
        key: '2-0',
        data: { name: 'note-meeting.txt', size: '50kb', type: 'Text' },
      },
      {
        key: '2-1',
        data: { name: 'note-todo.txt', size: '100kb', type: 'Text' },
      },
    ],
  },
  {
    key: '3',
    data: { name: 'Documents', size: '75kb', type: 'Folder' },
    children: [
      {
        key: '3-0',
        data: { name: 'Work', size: '55kb', type: 'Folder' },
        children: [
          {
            key: '3-0-0',
            data: { name: 'Expenses.doc', size: '30kb', type: 'Document' },
          },
          {
            key: '3-0-1',
            data: { name: 'Resume.doc', size: '25kb', type: 'Resume' },
          },
        ],
      },
      {
        key: '3-1',
        data: { name: 'Home', size: '20kb', type: 'Folder' },
        children: [
          {
            key: '3-1-0',
            data: { name: 'Invoices', size: '20kb', type: 'Text' },
          },
        ],
      },
    ],
  },
  {
    key: '4',
    data: { name: 'Downloads', size: '25kb', type: 'Folder' },
    children: [
      {
        key: '4-0',
        data: { name: 'Spanish', size: '10kb', type: 'Folder' },
        children: [
          {
            key: '4-0-0',
            data: { name: 'tutorial-a1.txt', size: '5kb', type: 'Text' },
          },
          {
            key: '4-0-1',
            data: { name: 'tutorial-a2.txt', size: '5kb', type: 'Text' },
          },
        ],
      },
      {
        key: '4-1',
        data: { name: 'Travel', size: '15kb', type: 'Text' },
        children: [
          {
            key: '4-1-0',
            data: { name: 'Hotel.pdf', size: '10kb', type: 'PDF' },
          },
          {
            key: '4-1-1',
            data: { name: 'Flight.pdf', size: '5kb', type: 'PDF' },
          },
        ],
      },
    ],
  },
  {
    key: '5',
    data: { name: 'Main', size: '50kb', type: 'Folder' },
    children: [
      { key: '5-0', data: { name: 'bin', size: '50kb', type: 'Link' } },
      { key: '5-1', data: { name: 'etc', size: '100kb', type: 'Link' } },
      { key: '5-2', data: { name: 'var', size: '100kb', type: 'Link' } },
    ],
  },
  {
    key: '6',
    data: { name: 'Other', size: '5kb', type: 'Folder' },
    children: [
      { key: '6-0', data: { name: 'todo.txt', size: '3kb', type: 'Text' } },
      { key: '6-1', data: { name: 'logo.png', size: '2kb', type: 'Picture' } },
    ],
  },
  {
    key: '7',
    data: { name: 'Pictures', size: '150kb', type: 'Folder' },
    children: [
      {
        key: '7-0',
        data: { name: 'barcelona.jpg', size: '90kb', type: 'Picture' },
      },
      {
        key: '7-1',
        data: { name: 'primeng.png', size: '30kb', type: 'Picture' },
      },
      {
        key: '7-2',
        data: { name: 'prime.jpg', size: '30kb', type: 'Picture' },
      },
    ],
  },
  {
    key: '8',
    data: { name: 'Videos', size: '1500kb', type: 'Folder' },
    children: [
      {
        key: '8-0',
        data: { name: 'primefaces.mkv', size: '1000kb', type: 'Video' },
      },
      { key: '8-1', data: { name: 'intro.avi', size: '500kb', type: 'Video' } },
    ],
  },
];

export const events = [
  { id: 1, title: 'All Day Event', start: '2023-01-03' },
  { id: 2, title: 'Long Event', start: '2023-01-09', end: '2023-01-12' },
  { id: 3, title: 'Repeating Event', start: '2023-01-11T16:00:00' },
  { id: 4, title: 'Repeating Event', start: '2023-01-18T16:00:00' },
  { id: 5, title: 'Conference', start: '2023-01-13', end: '2023-01-15' },
  {
    id: 6,
    title: 'Meeting',
    start: '2023-01-14T10:30:00',
    end: '2023-01-14T12:30:00',
  },
  { id: 7, title: 'Lunch', start: '2023-01-14T12:00:00' },
  { id: 8, title: 'Meeting', start: '2023-01-14T14:30:00' },
  { id: 9, title: 'Happy Hour', start: '2023-01-14T17:30:00' },
  { id: 10, title: 'Dinner', start: '2023-01-14T20:00:00' },
  { id: 11, title: 'Birthday Party', start: '2023-01-15T07:00:00' },
  {
    id: 12,
    title: 'Click for Google',
    url: 'http://google.com/',
    start: '2023-01-30',
  },
];
